// angular
import { AfterViewInit, Component, ElementRef } from '@angular/core';

// local
import { AbstractQnaComponent } from '../abstract-qna.component';
import { QnaNavigationService } from '../qna-navigation.service';
import { QnaStage } from '@aa/selfserv/shared';

@Component({
  selector: 'aa-qna-start',
  templateUrl: './start.component.html'
})
export class QnaStartComponent extends AbstractQnaComponent implements AfterViewInit {

  // @ViewChild('startText', {static: false}) startText: ElementRef;
  // @ViewChild('startButton', {static: false}) startButton: ElementRef;

  constructor(navigation: QnaNavigationService) {
    super(navigation, 'Start', QnaStage.Start);
  }

  public ngAfterViewInit() {
    /*
    setTimeout(() => {
      this.focusElement(this.startText);
    });
    */
  }

  private focusElement(el: ElementRef) {
    if (!el) {
      console.warn('Failed to focus initial element');
      return;
    }

    el.nativeElement.focus();
  }
}
